import { AdmDataGrid } from "@components/common/data-grid/adm-data-grid";
import { AdmProject } from "@custom-types/base-types";
import { useSearchProjectsTableColumns } from "@pages/home/search/search-tables/search-projects-tables/use-search-projects-table-columns";
import { useGenerateRoutes } from "@router/router-helper";
import { MainPageEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

interface Props {
  /** List of projects that match the search text */
  projects: AdmProject[];
}

/** Shows a list of projects that match the search text */
export function SearchProjectsTable({ projects }: Props): React.JSX.Element {
  const columns = useSearchProjectsTableColumns();
  const { generateProjectRoute } = useGenerateRoutes();
  const { trackEvent } = useTrackEvent();

  return (
    <AdmDataGrid
      entities={projects}
      uniqueIdKey="id"
      tableType="search-projects-table"
      columns={columns}
      // Data is coming from somewhere else with error handling. So no need to show error in here.
      errorMessage=""
      shouldShowErrorMessage={false}
      onRowClick={() => {
        trackEvent({
          name: MainPageEvents.openItem,
          props: {
            target: "PROJECT",
            location: "search result",
          },
        });
      }}
      getRowLink={(project) => generateProjectRoute({ projectId: project.id })}
      defaultSortModel={[{ field: "name", sort: "asc" }]}
    />
  );
}
